import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import moment from "moment";
import TablaDetallesDesaprobaciones from "./tablaDetallesDesaprobaciones";
import {
  DangerButton,
  InfoButton,
  SuccessButton,
} from "../../ui/buttons/Button";
import { Input, SearchInput, Textarea } from "../../ui/inputs/Input";

export const DesaprobarCompromisos = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));

  const [activate, setActivate] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [activo, setActivo] = useState(true);
  const [operacion, setOperacion] = useState(0);
  const [datospre, setDatospre] = useState([]);
  const [valida, setValida] = useState([]);
  const [depart, setDepart] = useState(null);
  const [tip, setTip] = useState(null);
  const [ticomp, setTicomp] = useState(null);
  const [ubi, setUbi] = useState(null);
  const [pucc, setPucc] = useState(0);
  const [tituloapro, setTituloapro] = useState("");
  const [data, setData] = useState([]);
  const [body, setBody] = useState(null);
  const [codigo, setCodigo] = useState(0);
  const [titulo, setTitulo] = useState("");
  const [chek, setChek] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    idcuenta: "",
    auxiliar: "",
    descripcionaux: "",
    idcategoriaprogramatica: "",
    idpuc: "",
    puc: "",
    categoria: "",
    disponibilidad: 0.0,
    montoinicial: 0.0,
    tipopartida: "",
  });
  const txtFecha = useRef();
  const txtFechaAprobacion = useRef();
  const txtObservacion = useRef();
  const txtNp = useRef();
  const txtCodigo = useRef();

  const onChange = (event) => {
    if (
      event.target.name === "descriaux" ||
      event.target.name === "ubicacion" ||
      event.target.name === "observacion"
    ) {
      event.target.value = event.target.value.toUpperCase();
    }
  };
  const validarImpresion = () => {
    // Si es operación 2 (imprimir) y el documento está aprobado
    if (operacion === 2 && props.aprobado === true) {

      // Validaciones específicas según el contexto (basado en el código Java)
      if (props.ubica === 42 && props.tipocom === 0) {
        // Documento ya fue devuelto/enviado
        return true;
      }
      else if (props.ubica === 40 && props.tipocom === 2) {
        // Documento ya fue devuelto a Compras o enviado a Administración
        return true;
      }
      else if (props.ubica === 40 && props.tipocom === 3) {
        // Documento ya fue devuelto a Ingeniería o enviado a Administración
        return true;
      }
      else if (props.ubica === 41 && props.aprobado === true) {
        return true;
      }
      else if (props.ubica === 44 && props.aprobado === true) {
        return true;
      }
      else if (props.ubica === 38 && props.aprobado === true) {
        return true;
      }
      else if (props.ubica === 95 && props.aprobado === true) {
        return true;
      }
      else if (props.ubica === 90 && props.aprobado === true) {
        return true;
      }
      else if (props.ubica === 59 && props.tipocom === 2 && props.aprobado === true) {
        return true;
      }
      else if (props.ubica === 58 && props.tipocom === 2 && props.aprobado === true) {
        return true;
      }
      else if (props.ubica === 39 && props.tipocom === 3 && props.aprobado === true) {
        return true;
      }
      else if (props.ubica === 1 && props.tipocom === 4 && props.aprobado === true) {
        return true;
      }
      else if (props.ubica === 80 && props.aprobado === true) {
        return true;
      }
    }

    return false;
  };

  // Función para manejar la impresión
  const handleImprimir = () => {
    if (!validarImpresion()) {
      setMensaje({
        mostrar: true,
        titulo: 'Validación',
        texto: 'El documento debe estar aprobado para poder imprimir',
        icono: 'informacion'
      });
      return;
    }

    // Determinar el tipo de reporte según los parámetros
    let fileName = '';
    let nombreid = '';
    let nombreid1 = 'true';
    let monto = '';
    let condicion = '';
    let condicion2 = '';
    let titulo = '';
    let direccion = '';
    let direcciondev = '';
    let enca = props.tipo === 1 ? 'ENVIO' : 'DEVOLUCION';
    let estat = props.tipo === 1 ? 'envian para su debido proceso' : 'devuelven para su debida revisión';
    let proveedor = '';
    let selectDistinct = props.tipocom === 3 ? ' select distinct ' : '';

    // Obtener el ID de la aprobación (del registro actual o de props)
    const idAprobacion = props.aprobaciones?.idaprobaciones || txtCodigo.current?.value || codigo;

    // Configurar según tipocom (basado en el código Java)
    switch (parseInt(props.tipocom)) {
      case 0: // Compromisos
        fileName = 'compromiso';
        nombreid = 'idcompromiso';
        monto = 'montocompromiso';
        condicion = '';
        condicion2 = 'LEFT JOIN proveedor ON proveedor.idproveedor = compromiso.idproveedor';
        titulo = 'COMPROMISOS';
        proveedor = 'proveedor.razonsocial AS razonsocial';
        break;

      case 1: // Ordenes de Pago
        fileName = 'ordenpago';
        // Según el espíritu, puede ser numordenpago o idordenpago
        if ([0, 1, 9, 12, 13, 14, 15].includes(parseInt(espiritu))) {
          nombreid = 'ordenpago.numordenpago';
        } else {
          nombreid = 'ordenpago.idordenpago';
        }
        nombreid1 = 'ordenpago.idordenpago';
        monto = 'montoordenpago';
        condicion = `LEFT JOIN compromiso ON compromiso.idcompromiso = ordenpago.idcompromiso and compromiso.idefiscal = ${idefiscal}`;
        condicion2 = 'LEFT JOIN proveedor ON proveedor.idproveedor = compromiso.idproveedor or proveedor.idproveedor = ordenpago.idproveedororden';
        titulo = 'ORDENES DE PAGO';
        proveedor = 'proveedor.razonsocial AS razonsocial';
        break;

      case 2: // Solicitudes de Compras/Servicios
        fileName = 'ordencompra';
        if ([8, 9, 14, 15].includes(parseInt(espiritu))) {
          nombreid = '(CASE WHEN aprobacionesdetalle.tipo = 0 then idordencompra else idordenservicio end)';
        } else {
          nombreid = 'idordencompra';
        }
        monto = 'monto + montoiva';
        condicion = '';
        condicion2 = 'LEFT JOIN proveedor ON proveedor.idproveedor = ordencompra.idproveedor';
        titulo = 'SOLICITUDES DE COMPRAS/SERVICIOS';
        proveedor = 'proveedor.razonsocial AS razonsocial';
        break;

      case 3: // Solicitudes de Pago de Obras
        fileName = 'solicitudpagoobras';
        nombreid = 'idsolicitudpagoobras';
        monto = 'monto';
        condicion = 'LEFT JOIN obraasignada ON obraasignada.idobraasignada = solicitudpagoobras.idobraasignada';
        condicion2 = 'LEFT JOIN proveedor ON proveedor.idproveedor = obraasignada.idproveedor';
        titulo = 'SOLICITUDES DE PAGO DE OBRAS y SERVICIOS';
        proveedor = 'proveedor.razonsocial AS razonsocial';
        break;

      case 4: // Solicitud de Traslado de Fondos
        fileName = 'retenciondetalle';
        nombreid = 'idaprobacion';
        monto = 'montototalaprob';
        condicion = `LEFT JOIN retenciondetalle ON retenciondetalle.idaprobacion = aprobacionesdetalle.idordenpago and retenciondetalle.idefiscal <= ${idefiscal}`;
        condicion2 = 'LEFT JOIN proveedor ON proveedor.idproveedor = 20';
        titulo = 'SOLICITUD DE TRASLADO DE FONDOS';
        proveedor = 'proveedor.razonsocial AS razonsocial';
        break;

      case 5: // Presupuesto Base
        fileName = 'presupuestobase';
        nombreid = 'idpresupuestobase';
        monto = 'monto + montoiva';
        condicion = '';
        condicion2 = '';
        titulo = 'PRESUPUESTO BASE';
        proveedor = 'null AS razonsocial';
        break;

      case 6: // Precompromisos
        fileName = 'precompromiso';
        nombreid = 'idprecompromiso';
        monto = 'montocompromiso';
        condicion = '';
        condicion2 = '';
        titulo = 'PRECOMPROMISOS';
        proveedor = "'' AS razonsocial";
        break;

      case 7: // Solicitudes de Donaciones
        fileName = 'ordencompra';
        nombreid = 'idordendonacion';
        monto = 'monto + montoiva';
        condicion = '';
        condicion2 = 'LEFT JOIN proveedor ON proveedor.idproveedor = ordencompra.idproveedor';
        titulo = 'SOLICITUDES DE DONACIONES';
        proveedor = 'proveedor.razonsocial AS razonsocial';
        break;

      default:
        fileName = 'compromiso';
        nombreid = 'idcompromiso';
        monto = 'montocompromiso';
        titulo = 'DOCUMENTOS';
        proveedor = 'null AS razonsocial';
    }

    // Configurar direcciones según ubicación (basado en el código Java)
    if (props.ubica === 42) {
      if (props.tipocom === 0) {
        direccion = 'Administración';
        direcciondev = props.tipo === 0 ? 'Director de Administracion' : 'Unidad de Tesoreria';
      } else {
        direccion = 'Administración';
        direcciondev = props.tipo === 0 ? 'Director de Administracion' : 'Unidad de Tesoreria';
      }
    } else if (props.ubica === 48) {
      direccion = 'Tesorería';
      direcciondev = 'Unidad de Control Posterior';
    } else if (props.ubica === 41) {
      if (props.tipo === 0) {
        direccion = 'Control Posterior';
        direcciondev = 'Unidad de Tesoreria';
      } else {
        direccion = 'Control Posterior';
        direcciondev = 'Unidad de Contabilidad';
      }
    } else if (props.ubica === 44) {
      direccion = 'Unidad de Tesoreria';
      direcciondev = 'Unidad de Administración';
    } else if (props.ubica === 40) {
      if (props.tipocom === 2) {
        direccion = 'Presupuesto';
        direcciondev = props.tipo === 0 ? 'Unidad de Compras' : 'Unidad de Administración';
      } else if (props.tipocom === 3) {
        direccion = 'Unidad de Administración';
        direcciondev = props.tipo === 0 ? 'Dirección de Ingeniería Municipal' : 'Unidad de Administración';
      } else if (props.tipocom === 0) {
        direccion = 'Presupuesto';
        direcciondev = props.tipo === 0 ? 'Dirección de Ingeniería Municipal' : 'Unidad de Administración';
      }
    } else if (props.ubica === 38) {
      if (props.tipo === 1) {
        direccion = parseInt(espiritu) === 8 ? 'Dirección de Administración' : 'Dirección de Compras';
        direcciondev = 'Dirección de Presupuesto';
      } else {
        direccion = parseInt(espiritu) === 8 ? 'Dirección de Administración' : 'División de Compras';
        direcciondev = 'Dirección de Presupuesto';
      }
    } else if (props.ubica === 95) {
      if (props.tipo === 1) {
        direccion = 'Despacho del Alcalde';
        direcciondev = 'Dirección de Presupuesto';
      } else {
        direccion = 'Dirección de Presupuesto';
        direcciondev = 'Despacho del Alcalde';
      }
    } else if (props.ubica === 58) {
      direccion = 'División de Compras';
      direcciondev = 'Dirección de Administración';
    } else if (props.ubica === 59) {
      direccion = 'Dirección de Presupuesto';
      direcciondev = 'Dirección de Administración';
    } else if (props.ubica === 1 && props.tipocom === 4) {
      if (props.tipo === 0) {
        direccion = 'Unidad de Administración';
        direcciondev = 'Unidad de Retención';
      } else {
        direccion = 'Unidad de Retención';
        direcciondev = 'Unidad de Administración';
      }
    } else if (props.ubica === 80) {
      direccion = 'Dirección de Compras';
      direcciondev = 'Dirección de Presupuesto';
    } else if (props.ubica === 90) {
      direccion = 'Presupuesto';
      direcciondev = 'Dirección de Compras';
    } else if (props.ubica === 39) {
      direccion = 'Ingeniería';
      direcciondev = props.tipo === 0 ? 'Dirección de Ingeniería Municipal' : 'Unidad de Administración';
    } else if (props.ubica === 43) {
      direccion = 'Contabilidad';
      direcciondev = 'Unidad de Contabilidad';
    }

    // Determinar el nombre del reporte según el tipo
    let reporteName = 'ControlDocumentos';
    if (props.tipocom === 4) {
      reporteName = 'ControlDocumentosAprob';
    //} else if (props.tipocom === 1 && [0, 1, 9, 12, 13, 14, 15].includes(parseInt(espiritu))) {
    } else if (props.tipocom === 1) {
      reporteName = 'ControlDocumentosOrdenPago';
    }

    // Construir la URL para el reporte con TODOS los parámetros necesarios
    const reporteUrl = `${op.reportes}/administracionTesoreria?reporte=${reporteName}` +
      `&NOMTAB=${encodeURIComponent(fileName)}` +
      `&NOMID=${encodeURIComponent(nombreid)}` +
      `&NOMID1=${encodeURIComponent(nombreid1)}` +
      `&MONTO=${encodeURIComponent(monto)}` +
      `&CONDI=${encodeURIComponent(condicion)}` +
      `&CONDI2=${encodeURIComponent(condicion2)}` +
      `&TITULO=${encodeURIComponent(titulo)}` +
      `&DIRECCION=${encodeURIComponent(direccion)}` +
      `&DESTINO=${encodeURIComponent(direcciondev)}` +
      `&ENCABEZADO=${encodeURIComponent(enca)}` +
      `&DEVOLV=${encodeURIComponent(estat)}` +
      `&ID=${encodeURIComponent(idAprobacion)}` +
      `&EFISCAL=${encodeURIComponent(idefiscal)}` +
      `&PROVE=${encodeURIComponent(proveedor)}` +
      `&SELECT=${encodeURIComponent(selectDistinct)}`;

    console.log('Generando reporte con URL:', reporteUrl);

    // Abrir el reporte en nueva ventana
    window.open(
      reporteUrl,
      "ImpresionDocumento",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (txtObservacion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa la Observación",
        icono: "informacion",
      });
      sigue = false;
      txtObservacion.current.focus();
    } else if (valida === 0) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar las Solicitudes",
        icono: "informacion",
      });
      sigue = false;
    } else if (sigue) {
      let datos = [];
      let datost = [];
      let validad = [];

      if (operacion === 1) {
        datos.push({
          nid: 0,
          fec: txtFecha.current.value,
          obser: txtObservacion.current.value.trim(),
          tip: parseInt(ticomp),
          depart: parseInt(depart),
          idefi: idefiscal,
          devol: tip,
          aprob: true,
        });

        for (let e = 0; e < data.length; e++) {
          datost.push({
            nid: data[e].idaprobacionesdetalle,
            motiv: data[e].motivo,
            idorden: data[e].idordenpago,
            conce: data[e].concepto,
            idapro: 0,
            tip: parseInt(data[e].tipo),
          });
        }

        for (let i = 0; i < data.length; i++) {
          validad.push({
            idordencs: data[i].idordenpago,
            idefis: idefiscal,
            val: data[i].val,
            tipocom: parseInt(ticomp),
            tipo: tip,
            validaparam: data[i].validaparam,
          });
        }
      }

      setBody({
        operacion: operacion,
        aprobaciones: datos,
        aprobdetalles: datost,
        spiritu: espiritu,
        valida: validad,
        ubi: props.ubica,
      });
      console.log(datos);

      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Aprobar estos Documentos?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/presupuesto/crearaprobaciones`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Solicitud Aprobada Correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const blanquear = () => {
    setValues({
      idcuenta: "",
      auxiliar: "",
      descripcionaux: "",
      idcategoriaprogramatica: "",
      idpuc: "",
      puc: "",
      categoria: "",
      disponibilidad: 0.0,
      montoinicial: 0.0,
      tipopartida: "",
    });
    setDatospre([]);
    setActivate(false);
    setChek(0);
    setValida([]);
    setDepart(null);
    setTip(null);
    setUbi(null);
    setPucc(0);
    setData([]);
    setTicomp(null);
    setBody(null);
    setCodigo(0);
    setTituloapro("");
    setTitulo("");
    setActivo(true);
  };

  const handleCloseSi = () => {
    if (operacion === 1) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Actualizar();
    }
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancelar();
    blanquear();
  };

  const BaseDatos = (data) => {
    if (data.length > 0) {
      setActivo(false);
      setValida(1);
    } else {
      setActivo(true);
      setValida(0);
    }
    setData(data);
    console.log(data);
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          setValues(props.aprobaciones);
          setDatospre(props.aprodetalle);
          let definic;
          let env;

          if (props.ubica === 42 && props.tipocom === 0) {
            if (props.tipo === 0) {
              definic = "Devuelto";
            } else {
              definic = "Enviado";
            }

            if (props.aprobado === true) {
              setTituloapro(
                <p className="text-success text-center">
                  ¡ El Documento ya fué {definic} a Administración !
                </p>
              );
            } else if (props.aprobado === false) {
              if (props.tipo === 0) {
                setTituloapro(
                  <p className="text-amber text-center">
                    ¡ El Documento esta por Devolver a Compras !
                  </p>
                );
              } else {
                setTituloapro(
                  <p className="text-amber text-center">
                    ¡ El Documento esta por Enviar a Administración !
                  </p>
                );
              }
            }
            setTitulo("Presupuesto - Solicitud de Compromiso [Consulta]");
          } else if (props.ubica === 90) {
            if (props.tipo === 0) {
              definic = "Devuelto";
            } else {
              definic = "Enviado";
            }

            if (props.aprobado === true) {
              setTituloapro(
                <p className="text-success text-center">
                  ¡ El Documento fué {definic} a Compras !
                </p>
              );
            }
            setTitulo(
              "Presupuesto - Orden de Pago (Imputacioón Aprobada) a Division de Compras [Consulta]"
            );
          } else if (props.devolver === 1) {
            if (props.tipo === 0) {
              definic = "Devuelto";
              env = "Devolver";
            } else {
              definic = "Enviado";
              env = "Enviar";
            }

            if (props.ubica === 40 && props.tipocom === 2) {
              if (props.aprobado === true) {
                if (props.tipo === 0) {
                  setTituloapro(
                    <p className="text-success text-center">
                      ¡ El Documento ya Fué {definic} a Compras !
                    </p>
                  );
                } else {
                  setTituloapro(
                    <p className="text-amber text-center">
                      ¡ El Documento ya Fué {definic} a Administración !
                    </p>
                  );
                }
              }
              setTitulo("Presupuesto - Solicitud de Compras [Consulta]");
            } else if (props.ubica === 59 && props.tipocom === 2) {
              if (props.aprobado === true) {
                setTituloapro(
                  <p className="text-success text-center">
                    ¡ El Documento esta por{" "}
                    {props.tipo === 0 ? "Devolver" : "Enviar"} a Administración
                    !
                  </p>
                );
              } else if (props.aprobado === false) {
                setTituloapro(
                  <p className="text-amber text-center">
                    ¡ El Documento ya Fué {definic} a Administración !
                  </p>
                );
              }
              setTitulo(
                "Presupuesto - Solicitud de Compras/Servicios [Consulta]"
              );
            } else if (props.ubica === 40 && props.tipocom === 3) {
              if (props.aprobado === true) {
                if (props.tipo === 0) {
                  setTituloapro(
                    <p className="text-success text-center">
                      ¡ El Documento ya Fué {definic} al Dto. Ingeniería !
                    </p>
                  );
                } else {
                  setTituloapro(
                    <p className="text-amber text-center">
                      ¡ El Documento ya Fué {definic} a Administración !
                    </p>
                  );
                }
              }
              setTitulo(
                "Unidad de Administración - Devolver Solicitud de Pago [Consulta]"
              );
            } else if (props.ubica === 95 && props.tipocom === 7) {
              if (props.aprobado === true) {
                setTituloapro(
                  <p className="text-success text-center">
                    ¡ El Documento ya Fué {definic} a Presupuesto !
                  </p>
                );
              } else if (props.aprobado === false) {
                setTituloapro(
                  <p className="text-amber text-center">
                    ¡ El Documento esta por {env} a Despacho !
                  </p>
                );
              }

              if (props.tipo === 1) {
                setTitulo("Despacho - Solicitud de Donación [Consulta]");
              } else {
                setTitulo("Presupuesto - Solicitud de Donación [Consultar]");
              }
            }
          }
        } else {
          txtObservacion.current.value = "";
          txtFecha.current.value = moment.utc(fechaSistema).format("YYYY-MM-DD");
          txtCodigo.current.value = "";

          let definic;

          if (props.ubica === 42 && props.tipocom === 0) {
            if (props.tipo === 0) {
              definic = "Devolver";
            } else {
              definic = "Enviar";
            }
            setDepart(2);
            setTip(props.tipo);
            setTicomp(props.tipocom);
            setTitulo("Administración - " + definic + " Compromiso");
          } else if (props.ubica === 90) {
            if (props.tipo === 0) {
              definic = "Devolver";
            } else {
              definic = "Enviar";
            }
            setDepart(1);
            setTip(props.tipo);
            setTicomp(props.tipocom);
            setTitulo(
              "Presupuesto - " +
              definic +
              " Orden de Pago (Imputacioón Aprobada) a Division de Compras"
            );
          } else if (props.devolver === 1) {
            if (props.tipo === 0) {
              definic = "Devolver";
            } else {
              definic = "Enviar";
            }

            if (props.ubica === 40 && props.tipocom === 2) {
              setDepart(1);
              setTip(props.tipo);
              setTicomp(props.tipocom);
              setTitulo(
                "Presupuesto - " + definic + " Solicitud de Compromiso"
              );
            } else if (props.ubica === 59 && props.tipocom === 2) {
              setDepart(9);
              setTip(props.tipo);
              setTicomp(props.tipocom);
              setTitulo(
                "Presupuesto - " + definic + " Solicitud de Compras/Servicios"
              );
            } else if (props.ubica === 40 && props.tipocom === 3) {
              setDepart(1);
              setTip(props.tipo);
              setTicomp(props.tipocom);
              setTitulo(
                "Unidad de Administración - " + definic + " Solicitud de Pago"
              );
            } else if (props.ubica === 95 && props.tipocom === 7) {
              setDepart(4);
              setTip(props.tipo);
              setTicomp(props.tipocom);

              if (props.tipo === 1) {
                setTitulo("Despacho - " + definic + " Solicitud de Donación");
              } else {
                setTitulo(
                  "Presupuesto - " + definic + " Solicitud de Donación"
                );
              }
            }
          }

          /* console.log(props.ubica);
                    console.log(props.tipo);
                    console.log(props.tipocom);
                    console.log(props.devolver); */
        }
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>
            {operacion === 1
              ? titulo
              : operacion === 2
                ? titulo
                : operacion === 3
                  ? titulo
                  : titulo}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Dimmer active={activate} inverted></Dimmer>
        <input type="hidden" ref={txtNp} />

        <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded ">
          <legend className="float-none m-0 w-auto">Datos</legend>

          <div className="col-2 m-0 p-0">
            <Input label='Código:'
              name="observacion"
              disabled={true}
              ref={txtCodigo}
              defaultValue={
                props.aprobaciones
                  ? props.aprobaciones.idaprobaciones.trim()
                  : ""
              }
              id="inputDireccion"
            />
          </div>

          <div className="col-8 m-0 p-0">
            {/* <h3> {tituloapro} </h3> */}
          </div>

          <div className="col-2 m-0 p-0">
            <Input label='Fecha:'
              type="date"
              disabled={
                operacion === 4 || operacion === 2 ? true : deshabilitado
              }
              defaultValue={
                props.aprobaciones && props.aprobaciones.fecha !== ""
                  ? moment.utc(props.aprobaciones.fecha).format("YYYY-MM-DD")
                  : moment.utc(fechaSistema).format("YYYY-MM-DD")
              }
              id="inputDireccion"
              ref={txtFecha}
            />
          </div>
          <div className="col-12 m-0 mt-2 p-0">
            <Textarea label='Observación'
              style={{ height: 70 }}
              name="observacion"
              onChange={onChange}
              disabled={
                operacion === 4 || operacion === 2 ? true : deshabilitado
              }
              defaultValue={
                props.aprobaciones
                  ? props.aprobaciones.observaciones.trim()
                  : ""
              }
              placeholder="Descripción de la Observación"
              id="inputDireccion"
              ref={txtObservacion}
            />
          </div>
        </fieldset>

        <fieldset className="col-12 m-0 p-2 border-azul rounded">
          <legend className="float-none m-0 w-auto">
            {props.ubica === 90 && props.tipocom === 7
              ? "Detalles del Documento - [IMPUTACIÓN]"
              : props.ubica === 40 && props.tipocom === 0
                ? "Detalles del Documento - [COMPROMISO]"
                : props.devolver === 1
                  ? "Detalles del Documento"
                  : "Detalles"}
          </legend>
          <TablaDetallesDesaprobaciones
            data={BaseDatos}
            devolverc={props.devolver}
            ubi={props.ubica}
            tipocom={props.tipocom}
            datarecords={datospre}
            operacion={operacion}
          />
        </fieldset>
      </Modal.Body>
      <Modal.Footer>
        {operacion === 2 ? (
          <InfoButton onClick={handleImprimir} icon="fa-print">Imprimir</InfoButton>
        ) : (
          <SuccessButton onClick={onChangeValidar} disabled={activo}>
            Aceptar
          </SuccessButton>
        )}
        <DangerButton onClick={cancelar}>Cancealr</DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};
